import React, { memo, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './WhatWeDo.css';

const features = [
  { icon: 'bi-clock', title: 'Instant Approval', description: 'Loan approval in minutes — no waiting, immediate action.' },
  { icon: 'bi-shield-check', title: 'No Credit Check', description: 'No credit history? No worries. Enjoy easy, hassle-free loans designed for you.' },
  { icon: 'bi-calendar-check', title: 'Flexible Repayment', description: 'Select repayment options designed to align with your income cycle and financial commitments.' },
  { icon: 'bi-cash-stack', title: 'Same Day Deposit', description: 'Funds credited to your account within the same business day' },
  { icon: 'bi-piggy-bank', title: 'Low Interest Rates', description: 'Low rates crafted to enhance your financial growth. ' },
  { icon: 'bi-people', title: 'Friendly Support', description: 'Professional support tailored to your needs throughout.' },
];

const WhatWeDo = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const cards = sectionRef.current.querySelectorAll('.whatwedo__card');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-up-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    cards.forEach(card => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="whatwedo__section" ref={sectionRef}>
      <div className="container">
        <header className="whatwedo__header text-center mb-5">
          <h2 className="whatwedo__heading">What We Do</h2>
          <p className="whatwedo__subtext">
            We offer swift, flexible personal loans crafted to provide essential financial support during emergencies and short-term needs with complete transparency.
          </p>
        </header>

        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
          {features.map(({ icon, title, description }, index) => (
            <div key={index} className="col d-flex">
              <article className="whatwedo__card text-center">
                <div className="whatwedo__icon-wrapper">
                  <i className={`bi ${icon} whatwedo__icon`} aria-hidden="true"></i>
                </div>
                <h3 className="whatwedo__title">{title}</h3>
                <p className="whatwedo__desc">{description}</p>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default memo(WhatWeDo);
